export default __webpack_public_path__ + "static/media/holiday_inn_middletown.1eb50451.jpg";